import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const _import = require('./_import_' + process.env.NODE_ENV)

export default new VueRouter({
    routes: [
        {
            path: '/',
            name: 'index',
            component: _import('index')
        },
        {
            path: '/about/vendor',
            name: 'about_vendor',
            meta: {
                loginRequired: false
            },
            component: _import('about/vendor')
        },
        {
            path: '/about/me',
            name: 'about_me',
            component: _import('about/me')
        },
        {
            path: '/about/pclogin',
            name: 'about_pclogin',
            component: _import('about/pclogin')
        },
        {
            path: '/auth/login',
            name: 'auth_login',
            component: _import('auth/login')
        },
        {
            path: '/auth/change_password',
            name: 'auth_password',
            component: _import('auth/change_password')
        },
        {
            path: '/exam/paper',
            name: 'student_exam_paper_list',
            component: _import('exam/paper/list')
        },
        {
            path: '/exam/paper/fault',
            name: 'exam_paper_fault',
            component: _import('exam/paper/fault')
        },
        {
            path: '/exam/paper/favorite',
            name: 'exam_paper_favorite',
            component: _import('exam/paper/favorite')
        },
        {
            path: '/exam/exam/create',
            name: 'exam_exam_create',
            component: _import('exam/exam/create')
        },
        {
            path: '/exam/exam/manage',
            name: 'exam_exam_manage',
            component: _import('exam/exam/manage')
        },
        {
            path: '/exam/exam/:id/edit',
            name: 'exam_exam_edit',
            component: _import('exam/exam/edit')
        },
        {
            path: '/exam/exam/:id/score',
            name: 'exam_exam_score',
            component: _import('exam/exam/score')
        },
        {
            path: '/exam/exam/:id/review',
            name: 'exam_exam_review',
            component: _import('exam/exam/review')
        },
        {
            path: '/exam/exam/:id/preview',
            name: 'exam_exam_preview',
            component: _import('exam/exam/preview')
        },
        {
            path: '/exam/paper/:id',
            name: 'exam_paper_detail',
            component: _import('exam/paper/detail')
        },
        {
            path: '/exam/exam/:id',
            name: 'exam_exam_detail',
            component: _import('exam/exam/detail')
        },
        {
            path: '/exam/exam',
            name: 'exam_exam_list',
            component: _import('exam/exam/list')
        },
        {
            path: '/exam/fault',
            name: 'exam_fault_list',
            component: _import('exam/fault/list')
        },
        {
            path: '/media/video/:id',
            name: 'media_video_detail',
            component: _import('media/video/detail')
        },
        {
            path: '/media/video',
            name: 'media_videolist',
            component: _import('media/video/list')
        },
        {
            path: '/media/image/:id',
            name: 'media_image_detail',
            component: _import('media/image/detail')
        },
        {
            path: '/comment/comment/new',
            name: 'comment_comment_edit',
            component: _import('comment/comment/edit')
        },
        {
            path: '/comment/comment',
            name: 'comment_comment_list',
            component: _import('comment/comment/list')
        },
        {
            path: '/comment/comment/:id',
            name: 'comment_comment_detail',
            component: _import('comment/comment/detail')
        },
        {
            path: '/course/course',
            name: 'course_course_list',
            component: _import('course/course/list')
        },
        {
            path: '/course/course/:id',
            name: 'course_course_detail',
            component: _import('course/course/detail')
        },
        {
            path: '/course/report',
            name: 'course_course_report',
            component: _import('course/course/report')
        },
        {
            path: '/survey/survey/:id',
            name: 'survey_survey_detail',
            component: _import('survey/survey/detail')
        },
        {
            path: '/todo/todo',
            name: 'todo_todo_list',
            component: _import('todo/todo/list')
        },
        {
            path: '/message/message',
            name: 'message_message_list',
            component: _import('message/message/list')
        },
        {
            path: '/school/student/binding',
            component: _import('school/student/binding')
        },
        {
            path: '/school/student/trial_application',
            component: _import('school/student/trial_application')
        },
        {
            path: '/points/category/ranks',
            name: 'points_category_ranks',
            component: _import('points/category/ranks')
        },
        {
            path: '/points/category/:id',
            name: 'points_category_detail',
            component: _import('points/category/detail')
        },
        {
            path: '/clockin/group/mine',
            name: 'clockin_group_mine',
            component: _import('clockin/group/mine')
        },
        {
            path: '/test',
            component: _import('test')
        },
        {
            path: '/clear_cache',
            component: _import('clear_cache')
        },
        {
            path: '/test_video',
            meta: {loginRequired: false},
            component: _import('test_video')
        },
        {path: '/404', component: _import('errorPage/404'), hidden: true},
        {path: '/401', component: _import('errorPage/401'), hidden: true}
    ],
    // mode: 'history',
    // scrollBehavior (to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0}
    //     }
    // }
})



// WEBPACK FOOTER //
// ./src/router/index.js